import { request } from '../core';
import BaseOptions from './base';

class AirGroundApi extends BaseOptions {
  public checkSite(): Promise<any> {
    const requestOptions: RequestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/airGround/checkSite',
      method: 'POST',
      headers: this.requestHeaders
    };

    return request(requestOptions);
  }

  public getVehicleList(): Promise<any> {
    const requestOptions: RequestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/airGround/getVehicleList',
      method: 'POST',
      headers: this.requestHeaders
    };

    return request(requestOptions);
  }
}

export default AirGroundApi;
